// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
	$w("#image44").link = "http://google.com";
});

export function fullWidthSlides4_click(event) {
	//Add your code for this event here: 
}

export function image44_click(event) {
	//Add your code for this event here: 
}

export function vectorImage10_click(event) {
	//Add your code for this event here: 
}

export function vectorImage10_mouseOut(event) {
	//Add your code for this event here: 
}

export function box5_dblClick(event) {
	//Add your code for this event here: 
}